import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SortablejsModule } from 'angular-sortablejs';
import { OrderModule } from 'ngx-order-pipe';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

/* Components */
import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { LoginComponent } from './layout/login/login.component';
import { KindsModalComponent } from './layout/kindsmodal/kindsmodal.component';
import { CallComponent } from './actions/call/call.component';
import { InformationComponent } from './layout/information/information.component';
import { CancelComponent } from './actions/cancel/cancel.component';
import { AtypesComponent } from './layout/atypes/atypes.component';
import { ModalComponent } from './components/modal/modal.component';
import { PauseComponent } from './actions/pause/pause.component';
import { RedirectComponent } from './actions/redirect/redirect.component';
import { StatusComponent } from './actions/status/status.component';
import { MessageComponent } from './layout/message/message.component';
import { LanguagePipe } from './services/language.pipe';
import { RecoverfinishedComponent } from './actions/recoverfinished/recoverfinished.component';
import { PhoneComponent } from './actions/phone/phone.component';
import { ChangeListComponent } from './actions/changelistkind/changelistkind.component';
import { DeleteComponent } from './actions/delete/delete.component';

/* Services */
import { BusinesLogicService } from './services/business-logic.service';
import { UtilsService } from './services/utils.service';
import { DataService } from './services/data.service';
import { ModalHelper } from './components/modal/modal.helper';
import { LanguageService } from './services/language.service';
import { SocketService } from './services/socket.service';
import { ListComponent } from './layout/list/list.component';
import { NotificationService } from './services/notification.service';
import { DatePipe } from '@angular/common';
import { HistoryComponent } from './layout/history/history.component';

import { FilterPipeModule } from 'ngx-filter-pipe';
import { PostponeComponent } from './actions/postpone/postpone.component';
import { DeskQueueComponent } from './layout/deskqueue/deskqueue.component';

import { HttpErrorFilter } from './services/http-error-filter.service';
import { HttpFilter } from './services/http-filter.service';
import { DeskStatusComponent } from './actions/deskstatus/deskstatus.component';
import { StopdeskComponent } from './actions/stopdesk/stopdesk.component';
import { DeskStateService } from './services/desk-state.service';
import { BusinessEventService } from './services/business-event.service';
import { ChatService } from './services/chat.service';
import { TurnService } from './services/turn.service';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    LoginComponent,
    CallComponent,
    InformationComponent,
    CancelComponent,
    AtypesComponent,
    ModalComponent,
    PauseComponent,
    HistoryComponent,
    RedirectComponent,
    StatusComponent,
    LanguagePipe,
    KindsModalComponent,
    ListComponent,
    RecoverfinishedComponent,
    ChangeListComponent,
    PhoneComponent,
    StopdeskComponent,
    DeleteComponent,
    MessageComponent,
    PostponeComponent,
    DeskQueueComponent,
    DeskStatusComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    FilterPipeModule,
    OrderModule,
    SortablejsModule.forRoot({ animation: 200 }),
  ],
  providers: [
    BusinesLogicService,
    UtilsService,
    DataService,
    LanguageService,
    NotificationService,
    ModalHelper,
    LanguagePipe,
    DatePipe,
    SocketService,
    DeskStateService,
    BusinessEventService,
    ChatService,
    TurnService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorFilter, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpFilter, multi: true },
  ],
  bootstrap: [
    AppComponent
  ]
})
export class AppModule { }
